import { nanoid } from 'nanoid';
import { OperationContext } from '../types';
import { validateMetaStructure } from '../../utils/propertyPanel.ts';

export const createCloneHandler = (context: OperationContext) => {
  const { meta, onChange, selectedPath, setSelectedPath } = context;

  return (key: string) => {
    try {
      if (!selectedPath) {
        throw new Error("No target path selected");
      }

      // 1. 找到源配置
      const sourceConfig = meta.setters.props.find(
        (prop) => prop.name === key
      );
      if (!sourceConfig) {
        throw new Error(`Field ${key} not found`);
      }

      // 2. 生成新配置
      const newName = `${key}_copy_${nanoid(6)}`;
      const newConfig = {
        ...sourceConfig,
        name: newName,
        title: `${sourceConfig.title} (副本)`,
      };

      // 3. 解析路径找到目标位置
      const pathParts = selectedPath.split(".");
      const sectionName = pathParts[2];
      const itemName = pathParts[4];

      // 4. 创建新的 meta
      const newMeta = {
        ...meta,
        setters: {
          props: [...meta.setters.props, newConfig],
          layout: meta.setters.layout.map((section) => {
            if (section.name !== sectionName) return section;
            return {
              ...section,
              items: section.items.map((item) => {
                if (item.name !== itemName) return item;
                return {
                  ...item,
                  fields: [...item.fields, `setters/props/${newName}`],
                };
              }),
            };
          }),
        },
        defaultValues: {
          props: {
            ...meta.defaultValues.props,
            [newName]: meta.defaultValues.props[key],
          },
        },
        transforms: { ...meta.transforms },
        datasource: { ...meta.datasource },
      };

      // 5. 验证并清理
      if (!validateMetaStructure(newMeta)) {
        throw new Error("Invalid meta structure after cloning");
      }

      // 6. 重置选中状态
      setSelectedPath(null);

      // 7. 通知更新
      onChange?.({
        type: "setMeta",
        data: newMeta,
      });
    } catch (error) {
      console.error("Clone operation failed:", error);
    }
  };
};